import React from 'react';
import { motion } from 'framer-motion';
interface PageTransitionProps {
  children: React.ReactNode;
}
export const PageTransition = ({
  children
}: PageTransitionProps) => {
  return <motion.div initial={{
    opacity: 0,
    scale: 1.1
  }} animate={{
    opacity: 1,
    scale: 1
  }} exit={{
    opacity: 0,
    scale: 1.15
  }} transition={{
    duration: 0.6,
    ease: [0.16, 1, 0.3, 1]
  }} data-id="element-156">
      {children}
    </motion.div>;
};